// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   Typography,
//   IconButton,
//   Chip,
//   useMediaQuery,
//   useTheme,
//   Card,
//   CardContent,
//   Modal,
// } from "@mui/material";
// import {
//   Favorite,
//   FavoriteBorder,
//   ArrowForwardIos,
//   ArrowBackIos,
//   Speed,
//   LocalGasStation,
//   ColorLens,
//   Event
// } from "@mui/icons-material";
// import { useDispatch, useSelector } from 'react-redux';
// import { addToWishlist, fetchWishlist, fetchCart } from './store';
// import { useSnackbar } from 'notistack';
// import axios from 'axios';
// import InquiryModal from "./inquiryModal";

// const AffordableCarSection = () => {
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const dispatch = useDispatch();
//   const { enqueueSnackbar } = useSnackbar();

//   const [carModels, setCarModels] = useState([]);
//   const [carImages, setCarImages] = useState({});
//   const [imageLoading, setImageLoading] = useState({});
//   const [openInquiryModal, setOpenInquiryModal] = useState(false);
//   const [inquiryProduct, setInquiryProduct] = useState(null);
//   const [modalImage, setModalImage] = useState(null);
//   const [isRefreshing, setIsRefreshing] = useState(false);
  
//   // Add to Cart Dialog states
//   const [openDialog, setOpenDialog] = useState(false);
//   const [dialogType, setDialogType] = useState("");
//   const [selectedModelId, setSelectedModelId] = useState(null);

//   const wishlistItems = useSelector((state) => state.wishlist.items);
//   const cartItems = useSelector((state) => state.cart.items);
//   const scrollContainerRef = useRef(null);
//   const imageCache = useRef(new Map());

//   const enhancedCarModels = carModels.map(car => ({
//     ...car,
//     savings: Math.floor((car.carPrice || 0) * 0.15),
//     features: [
//       { icon: <Speed sx={{ fontSize: 16 }} />, label: `${car.carEngineCC || 'N/A'} CC` },
//       { icon: <Event sx={{ fontSize: 16 }} />, label: `${car.year || 'N/A'}` },
//       { icon: <LocalGasStation sx={{ fontSize: 16 }} />, label: car.carFuel || 'PETROL' },
//       { icon: <ColorLens sx={{ fontSize: 16 }} />, label: car.carColor || 'OTHER' }
//     ]
//   }));

//   // const fetchCarModels = useCallback(async (page = null) => {
//   //   try {
//   //     setIsRefreshing(true);
//   //     const pageToFetch = page !== null ? page : Math.floor(Math.random() * 8);
      
//   //     const response = await fetch(`https://car.amar.co.jp/api/master/affordable-car/get-all-affordable-car?page=${pageToFetch}&size=20`, {
//   //       headers: {
//   //         'accept': 'application/json',
//   //         'Accept-Language': 'en'
//   //       }
//   //     });
//   //     const data = await response.json();
//   //     setCarModels(data.data || []);
//   //   } catch (error) {
//   //     console.error("Error fetching car models:", error);
//   //   } finally {
//   //     setIsRefreshing(false);
//   //   }
//   // }, []);
// const fetchCarModels = useCallback(async (page = null) => {
//   try {
//     setIsRefreshing(true);

//     if (page === null) {
//       const firstRes = await fetch(`https://car.amar.co.jp/api/master/affordable-car/get-all-affordable-car?page=0&size=20`, {
//         headers: { 'accept': 'application/json', 'Accept-Language': 'en' }
//       });
//       const firstData = await firstRes.json();
//       const totalPages = firstData.totalPages || 1;
//       const randomPage = Math.floor(Math.random() * totalPages);

//       if (randomPage === 0) {
//         setCarModels(firstData.data || []);
//         return;
//       }

//       const response = await fetch(`https://car.amar.co.jp/api/master/affordable-car/get-all-affordable-car?page=${randomPage}&size=20`, {
//         headers: { 'accept': 'application/json', 'Accept-Language': 'en' }
//       });
//       const data = await response.json();
//       setCarModels(data.data || []);
//     } else {
//       const response = await fetch(`https://car.amar.co.jp/api/master/affordable-car/get-all-affordable-car?page=${page}&size=20`, {
//         headers: { 'accept': 'application/json', 'Accept-Language': 'en' }
//       });
//       const data = await response.json();
//       setCarModels(data.data || []);
//     }
//   } catch (error) {
//     console.error("Error fetching car models:", error);
//   } finally {
//     setIsRefreshing(false);
//   }
// }, []);
//   useEffect(() => {
//     fetchCarModels();
//   }, [fetchCarModels]);

//   const loadCarImages = useCallback(async (models) => {
//     const newImageLoading = {};
//     const newCarImages = {};
    
//     models.forEach(car => {
//       newImageLoading[car.carModelId] = true;
//     });
//     setImageLoading(newImageLoading);

//     const imagePromises = models.map(async (car) => {
//       const cacheKey = `car-exterior-${car.carModelId}`;
      
//       if (imageCache.current.has(cacheKey)) {
//         return {
//           carModelId: car.carModelId,
//           imageUrl: imageCache.current.get(cacheKey),
//           fromCache: true
//         };
//       }

//       try {
//         const imageUrl = `https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${car.carModelId}`;
        
//         return new Promise((resolve) => {
//           const img = new Image();
//           img.onload = () => {
//             imageCache.current.set(cacheKey, imageUrl);
//             resolve({
//               carModelId: car.carModelId,
//               imageUrl: imageUrl,
//               fromCache: false
//             });
//           };
//           img.onerror = () => {
//             resolve({
//               carModelId: car.carModelId,
//               imageUrl: null,
//               fromCache: false
//             });
//           };
//           img.src = imageUrl;
//         });
//       } catch (error) {
//         console.error("Error loading car image:", error);
//         return {
//           carModelId: car.carModelId,
//           imageUrl: null,
//           fromCache: false
//         };
//       }
//     });

//     const results = await Promise.allSettled(imagePromises);
    
//     results.forEach((result) => {
//       if (result.status === 'fulfilled') {
//         const { carModelId, imageUrl } = result.value;
//         newCarImages[carModelId] = imageUrl;
//         newImageLoading[carModelId] = false;
//       }
//     });

//     setCarImages(prev => ({ ...prev, ...newCarImages }));
//     setImageLoading(prev => ({ ...prev, ...newImageLoading }));
//   }, []);

//   useEffect(() => {
//     if (carModels.length > 0) {
//       loadCarImages(carModels);
//     }
//   }, [carModels, loadCarImages]);

//   const handleManualRefresh = () => {
//     fetchCarModels();
//   };

//   useEffect(() => {
//     const token = localStorage.getItem("authToken");
//     if (token) {
//       dispatch(fetchWishlist());
//       dispatch(fetchCart());
//     }
//   }, [dispatch]);

//   const checkImageExists = (url) => {
//     return new Promise((resolve) => {
//       const img = new Image();
//       img.onload = () => resolve(url);
//       img.onerror = () => resolve(null);
//       img.src = url;
//     });
//   };

//   const generateValidImageUrls = async (type, modelId, maxCount = 15) => {
//     const baseUrl = `https://car.amar.co.jp/api/image/car-${type}-images-`;
//     const urls = await Promise.allSettled(
//       Array.from({ length: maxCount }, (_, i) =>
//         checkImageExists(`${baseUrl}${i + 1}/get-image/${modelId}`)
//       )
//     );
//     return urls
//       .filter(result => result.status === 'fulfilled' && result.value)
//       .map(result => result.value);
//   };

//   const fetchProductData = async (carModelId) => {
//     try {
//       const response = await axios.get(
//         `https://car.amar.co.jp/api/dashboard/product/get/Model/details/${carModelId}`
//       );
//       return response.data?.data || null;
//     } catch (err) {
//       console.error('Error fetching product data:', err);
//       return null;
//     }
//   };

//   const handleInquiryClick = async (e, carModelId) => {
//     e.stopPropagation();
//     e.preventDefault();
    
//     console.log('Inquiry clicked for car:', carModelId);
    
//     try {
//       const productData = await fetchProductData(carModelId);
//       console.log('Product data received:', productData);
      
//       if (productData) {
//         setInquiryProduct(productData);
//         const imageUrls = await generateValidImageUrls("exterior", carModelId);
//         console.log('Image URLs:', imageUrls);
//         setModalImage(imageUrls[0] || 'carousel/carslider.png');
//         setOpenInquiryModal(true);
//       } else {
//         enqueueSnackbar('Failed to load car details for inquiry.', { variant: 'error' });
//       }
//     } catch (error) {
//       console.error('Error in handleInquiryClick:', error);
//       enqueueSnackbar('Error loading car details.', { variant: 'error' });
//     }
//   };

//   const handleInquiryClose = () => {
//     setOpenInquiryModal(false);
//     setInquiryProduct(null);
//     setModalImage(null);
//   };

//   const handleCarClick = (modelId) => {
//     navigate(`/product/${modelId}`);
//     window.scrollTo(0, 0);
//   };

//   // Add to Cart functionality
//   const handleAddToCart = async (e, carModelId) => {
//     e.stopPropagation();
//     try {
//       const token = localStorage.getItem("authToken");
//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const isInCart = cartItems.some((item) => item.modelId === carModelId);
//       if (isInCart) {
//         enqueueSnackbar("Item is already in your cart", { variant: "warning" });
//         return;
//       }

//       const isFavorite = wishlistItems.some((item) => item.modelId === carModelId);
      
//       if (isFavorite) {
//         setDialogType("move");
//         setSelectedModelId(carModelId);
//         setOpenDialog(true);
//         return;
//       }

//       const response = await fetch(
//         `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${carModelId}&SelectType=ADD_IN_CART`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({
//             modelId: carModelId,
//             type: "ADD_IN_CART",
//           }),
//         }
//       );

//       const data = await response.json();
//       if (data.code === 200) {
//         enqueueSnackbar("Added to cart successfully", { variant: "success" });
//         dispatch(fetchCart());
//       } else {
//         enqueueSnackbar(data.message || "Failed to add to cart", {
//           variant: "error",
//         });
//       }
//     } catch (error) {
//       enqueueSnackbar("Error adding to cart", { variant: "error" });
//       console.error("Error adding to cart:", error);
//     }
//   };

//   // Handle Move to Cart from Wishlist
//   const handleConfirmMove = async () => {
//     try {
//       const token = localStorage.getItem("authToken");
//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const response = await fetch(
//         `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${selectedModelId}&SelectType=MOVE_TO_CART`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Accept-Language": "en",
//             Authorization: `Bearer ${token}`,
//           },
//           body: "",
//         }
//       );

//       if (response.ok) {
//         enqueueSnackbar("Item moved to cart successfully", {
//           variant: "success",
//         });
//         dispatch(fetchWishlist());
//         dispatch(fetchCart());
//       } else {
//         const data = await response.json();
//         enqueueSnackbar(data.message || "Failed to move item to cart", {
//           variant: "error",
//         });
//       }
//     } catch (error) {
//       enqueueSnackbar("Error moving item to cart", { variant: "error" });
//       console.error("Error moving to cart:", error);
//     } finally {
//       setOpenDialog(false);
//       setSelectedModelId(null);
//       setDialogType("");
//     }
//   };

//   const handleFavoriteClick = async (e, carModelId) => {
//     e.stopPropagation();
//     try {
//       const token = localStorage.getItem("authToken");
//       if (!token) {
//         navigate("/login");
//         return;
//       }
//       const isFavorite = wishlistItems.some((item) => item.modelId === carModelId);
      
//       if (isFavorite) {
//         // Show remove confirmation dialog
//         setDialogType("removeWishlist");
//         setSelectedModelId(carModelId);
//         setOpenDialog(true);
//         return;
//       }
      
//       const result = await dispatch(addToWishlist(carModelId));
//       if (result.success) {
//         enqueueSnackbar("Added to wishlist successfully", { variant: "success" });
//       } else {
//         enqueueSnackbar(result.message || "Failed to add to wishlist", { variant: "error" });
//       }
//     } catch (error) {
//       enqueueSnackbar("Error adding to wishlist", { variant: "error" });
//       console.error("Error adding to wishlist:", error);
//     }
//   };

//   // Handle Remove from Wishlist
//   const handleConfirmRemoveWishlist = async () => {
//     try {
//       const token = localStorage.getItem("authToken");
//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const response = await fetch(
//         `https://car.amar.co.jp/api/master/car-cart-and-whishlist/delete/item?Enter%20ModelId=${selectedModelId}`,
//         {
//           method: "DELETE",
//           headers: {
//             accept: "application/json",
//             "Accept-Language": "en",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.ok) {
//         enqueueSnackbar("Item removed from wishlist successfully", {
//           variant: "success",
//         });
//         dispatch(fetchWishlist());
//       } else {
//         const data = await response.json();
//         enqueueSnackbar(data.message || "Failed to remove item from wishlist", {
//           variant: "error",
//         });
//       }
//     } catch (error) {
//       enqueueSnackbar("Error removing item from wishlist", { variant: "error" });
//       console.error("Error removing from wishlist:", error);
//     } finally {
//       setOpenDialog(false);
//       setSelectedModelId(null);
//       setDialogType("");
//     }
//   };

//   const isCarFavorite = (car) => {
//     return wishlistItems.some((item) => item.modelId === car.carModelId);
//   };

//   const handleSeeAllAffordableClick = () => {
//     navigate("/seeAllAffordableCarModels");
//   };

//   const scrollLeft = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: -600, behavior: 'smooth' });
//     }
//   };

//   const scrollRight = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({ left: 600, behavior: 'smooth' });
//     }
//   };

//   return (
//     <Box sx={{ width: "100%", py: 10, position: "relative", backgroundColor:"#F5FEF5" }}>
//       {/* Header Section with Refresh Button */}
//       <Box sx={{ textAlign: "center", mb: 4, position: 'relative' }}>
//         <Typography
//           variant="h2"
//           sx={{
//             fontWeight: 800,
//             fontSize: { xs: "2rem", md: "2.5rem" },
//             background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
//             backgroundClip: "text",
//             WebkitBackgroundClip: "text",
//             color: "transparent",
//             mb: 2,
//           }}
//         >
//           Affordable Cars
//         </Typography>
//         <Typography
//           variant="h6"
//           sx={{
//             color: "text.secondary",
//             maxWidth: "600px",
//             mx: "auto",
//             mb: 3,
//             fontSize: { xs: "0.9rem", md: "1.1rem" },
//             paddingInline:"5px",
//           }}
//         >
//           Quality vehicles that won't break the bank. Smart choices for smart buyers.
//         </Typography>

//         <Box sx={{ 
//           display: 'flex', 
//           justifyContent: 'center', 
//           alignItems: 'center',
//           gap: 2,
//           flexWrap: 'wrap'
//         }}>
//           <Button
//             variant="outlined"
//             onClick={handleManualRefresh}
//             disabled={isRefreshing}
//             sx={{
//               borderColor: "#28a745",
//               color: "#28a745",
//               px: 2,
//               py: 0.2,
//               borderRadius: "50px",
//               fontWeight: 600,
//               "&:hover": {
//                 backgroundColor: "#28a745",
//                 color: "white",
//                 transform: "translateY(-2px)",
//                 boxShadow: "0 8px 25px rgba(40, 167, 69, 0.3)",
//               },
//               "&:disabled": {
//                 borderColor: "#ccc",
//                 color: "#ccc",
//                 cursor: "not-allowed",
//                 transform: "none",
//                 boxShadow: "none",
//               },
//               transition: "all 0.3s ease",
//             }}
//           >
//             {isRefreshing ? "Refreshing..." : "Refresh Cars"}
//           </Button>

//           <Button
//             variant="outlined"
//             onClick={handleSeeAllAffordableClick}
//             sx={{
//               borderColor: "#28a745",
//               color: "#28a745",
//               px: 2,
//               py: 0.2,
//               borderRadius: "50px",
//               fontWeight: 600,
//               "&:hover": {
//                 backgroundColor: "#28a745",
//                 color: "white",
//                 transform: "translateY(-2px)",
//                 boxShadow: "0 8px 25px rgba(40, 167, 69, 0.3)",
//               },
//               transition: "all 0.3s ease",
//             }}
//           >
//             View All Affordable Cars
//           </Button>
//         </Box>
//       </Box>

//       {/* Navigation Arrows */}
//       {!isMobile && (
//         <>
//           <IconButton
//             onClick={scrollLeft}
//             sx={{
//               position: "absolute",
//               left: 10,
//               top: "50%",
//               transform: "translateY(-50%)",
//               backgroundColor: "white",
//               boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
//               "&:hover": {
//                 backgroundColor: "#28a745",
//                 color: "white",
//               },
//               zIndex: 10,
//             }}
//           >
//             <ArrowBackIos />
//           </IconButton>
//           <IconButton
//             onClick={scrollRight}
//             sx={{
//               position: "absolute",
//               right: 10,
//               top: "50%",
//               transform: "translateY(-50%)",
//               backgroundColor: "white",
//               boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
//               "&:hover": {
//                 backgroundColor: "#28a745",
//                 color: "white",
//               },
//               zIndex: 10,
//             }}
//           >
//             <ArrowForwardIos />
//           </IconButton>
//         </>
//       )}

//       {/* Enhanced Car Grid */}
//       <Box
//         ref={scrollContainerRef}
//         sx={{
//           display: "flex",
//           gap: 2,
//           overflowX: "auto",
//           scrollBehavior: "smooth",
//           px: { xs: 2, md: 6 },
//           py: 2,
//           "&::-webkit-scrollbar": { display: "none" },
//           msOverflowStyle: "none",
//           scrollbarWidth: "none",
//         }}
//       >
//         {enhancedCarModels.map((car) => {
//           const isFavorite = isCarFavorite(car);
//           const isInCart = cartItems.some((item) => item.modelId === car.carModelId);
          
//           return (
//             <Card
//               key={car.carModelId}
//               sx={{
//                 minWidth: 210,
//                 maxWidth: 290,
//                 flex: "0 0 auto",
//                 border: "none",
//                 borderRadius: 3,
//                 boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
//                 cursor: "pointer",
//                 transition: "all 0.3s ease",
//                 background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
//                 "&:hover": {
//                   transform: "translateY(-8px) scale(1.01)",
//                   boxShadow: "0 15px 40px rgba(40, 167, 69, 0.12)",
//                 },
//               }}
//               onClick={() => handleCarClick(car.carModelId)}
//             >
//               {/* Image Section */}
//               <Box
//                 sx={{
//                   position: "relative",
//                   height: 200,
//                   overflow: "hidden",
//                   borderTopLeftRadius: 12,
//                   borderTopRightRadius: 12,
//                   background: "linear-gradient(135deg, #f0fff4 0%, #e8f5e8 100%)",
//                 }}
//               >
//                 {imageLoading[car.carModelId] ? (
//                   <Box
//                     sx={{
//                       width: "100%",
//                       height: "100%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       backgroundColor: "#f5f5f5",
//                     }}
//                   >
//                     <Typography variant="body2" color="text.secondary">
//                       Loading...
//                     </Typography>
//                   </Box>
//                 ) : carImages[car.carModelId] ? (
//                   <img
//                     src={carImages[car.carModelId]}
//                     alt={car.carModelName}
//                     style={{
//                       width: "100%",
//                       height: "100%",
//                       objectFit: "cover",
//                       transition: "transform 0.3s ease",
//                     }}
//                     onLoad={(e) => {
//                       e.target.style.opacity = "1";
//                     }}
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = "/carousel/carslider.png";
//                     }}
//                   />
//                 ) : (
//                   <img
//                     src="/carousel/carslider.png"
//                     alt="Car placeholder"
//                     style={{
//                       width: "100%",
//                       height: "100%",
//                       objectFit: "cover",
//                     }}
//                   />
//                 )}

//                 {/* Favorite Button */}
//                 <IconButton
//                   sx={{
//                     position: "absolute",
//                     top: 8,
//                     right: 8,
//                     backgroundColor: "rgba(255,255,255,0.95)",
//                     backdropFilter: "blur(10px)",
//                     "&:hover": {
//                       backgroundColor: "white",
//                       transform: "scale(1.1)",
//                     },
//                     transition: "all 0.3s ease",
//                   }}
//                   onClick={(e) => handleFavoriteClick(e, car.carModelId)}
//                 >
//                   {isFavorite ? (
//                     <Favorite sx={{ color: "#eb2329" }} />
//                   ) : (
//                     <FavoriteBorder sx={{ color: "text.secondary" }} />
//                   )}
//                 </IconButton>

//                 {/* Value Tags */}
//                 <Box sx={{ position: "absolute", bottom: 8, left: 8, display: "flex", gap: 0.5 }}>
//                   {car.savings > 0 && (
//                     <Chip
//                       label={`Save $${car.savings}`}
//                       size="small"
//                       sx={{
//                         backgroundColor: "rgba(40, 167, 69, 0.9)",
//                         color: "white",
//                         fontSize: "0.65rem",
//                         fontWeight: 600,
//                         height: "20px",
//                         backdropFilter: "blur(10px)",
//                       }}
//                     />
//                   )}
//                 </Box>

//                                 {/* Badges Overlay */}
//                 <Box
//                   sx={{
//                     marginTop: "15px",
//                     marginLeft: "15px",
//                     display: "flex",
//                     gap: 0.5,
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   {car.ourPick && (
//                     <Chip
//                       label="Our Pick"
//                       size="small"
//                       sx={{
//                         fontSize: isMobile ? "0.55rem" : "0.65rem",
//                         height: isMobile ? "16px" : "26px",
//                         color: "#dd006e", // Neon pink
//                         backgroundColor: "#ffbddf",
//                         fontWeight: "bold",
//                         border: "1px solid #FF69B4",
//                         "&:hover": { backgroundColor: "white" },
//                       }}
//                     />
//                   )}
//                   {car.carGrade && (
//                     <Chip
//                       label={`Grade ${car.carGrade || "A"}`}
//                       size="small"
//                       sx={{
//                         fontSize: isMobile ? "0.55rem" : "0.65rem",
//                         height: isMobile ? "16px" : "26px",
//                         color: "#009966", // Neon mint
//                         backgroundColor: "#9fffe7",
//                         fontWeight: "bold",
//                         border: "1px solid #00FFAA",
//                         "&:hover": { backgroundColor: "white" },
//                       }}
//                     />
//                   )}
//                   {car.specialDeal && (
//                     <Chip
//                       label="Special Offer"
//                       size="small"
//                       sx={{
//                         fontSize: isMobile ? "0.55rem" : "0.65rem",
//                         height: isMobile ? "16px" : "26px",
//                         backgroundColor: "#d09fff",
//                         color: "#6c2aab", // Periwinkle
//                         fontWeight: "bold",
//                         border: "1px solid #6c2aab",
//                         "&:hover": { backgroundColor: "white" },
//                       }}
//                     />
//                   )}
//                 </Box>
                
//               </Box>

//               <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
//                 {/* Title and Info */}
//                 <Box sx={{ mb: 1.5 }}>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 700,
//                       fontSize: "1.1rem",
//                       lineHeight: 1.3,
//                       mb: 0.5,
//                       background: "linear-gradient(135deg, #2c3e50 0%, #34495e 100%)",
//                       backgroundClip: "text",
//                       WebkitBackgroundClip: "text",
//                       color: "transparent",
//                     }}
//                   >
//                     {car.carModelName}
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: "text.secondary",
//                       fontSize: "0.85rem",
//                       mb: 1.5,
//                     }}
//                   >
//                     {car.carCategoriesName}
//                   </Typography>
//                 </Box>

//                 {/* Features Grid */}
//                 <Box
//                   sx={{
//                     display: "grid",
//                     gridTemplateColumns: "repeat(2, 1fr)",
//                     gap: 1,
//                     mb: 2,
//                   }}
//                 >
//                   {car.features?.map((feature, index) => (
//                     <Box
//                       key={index}
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 0.5,
//                         color: "text.secondary",
//                       }}
//                     >
//                       {feature.icon}
//                       <Typography variant="caption" sx={{ fontWeight: 500 }}>
//                         {feature.label}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Box>

//                 {/* Price Section */}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     pt: 1.5,
//                     borderTop: "1px solid",
//                     borderColor: "divider",
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       color: "text.secondary",
//                       fontWeight: 400,
//                       display: "block",
//                       fontSize:'17px'
//                     }}
//                   >
//                     Starting from
//                   </Typography>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 600,
//                       color: "#28a745",
//                       background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
//                       backgroundClip: "text",
//                       WebkitBackgroundClip: "text",
//                       color: "transparent",
//                     }}
//                   >
//                     {car.carPrice ? `$${car.carPrice.toLocaleString()}` : "Contact Us"}
//                   </Typography>
//                 </Box>

//                 {/* Action Buttons */}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     marginTop: "10px",
//                     gap: 2,
//                   }}
//                 >
//                   {/* <Button
//                     variant="contained"
//                     onClick={(e) => handleAddToCart(e, car.carModelId)}
//                     disabled={isInCart}
//                     sx={{
//                       flex: 1,
//                       backgroundColor: "#28a745",
//                       borderRadius: "20px",
//                       px: 2.5,
//                       py: 0.8,
//                       fontWeight: 600,
//                       textTransform: "none",
//                       boxShadow: "0 3px 12px rgba(40, 167, 69, 0.3)",
//                       minHeight: "40px",
//                       whiteSpace: "nowrap",
//                       "&:hover": {
//                         backgroundColor: "#218838",
//                         transform: "translateY(-1px)",
//                         boxShadow: "0 6px 20px rgba(40, 167, 69, 0.4)",
//                       },
//                       "&:disabled": {
//                         backgroundColor: "#cccccc",
//                         cursor: "not-allowed",
//                       },
//                       transition: "all 0.3s ease",
//                     }}
//                   >
//                     {isFavorite
//                       ? "MOVE TO CART"
//                       : isInCart
//                       ? "ADDED"
//                       : "ADD TO CART"}
//                   </Button> */}

//                   <Button
//                     variant="contained"
//                     onClick={(e) => handleInquiryClick(e, car.carModelId)}
//                     sx={{
//                       flex: 1,
//                       backgroundColor: "#28a745",
//                       borderRadius: "20px",
//                       px: 2.5,
//                       py: 0.8,
//                       fontWeight: 600,
//                       textTransform: "none",
//                       boxShadow: "0 3px 12px rgba(40, 167, 69, 0.3)",
//                       minHeight: "40px",
//                       whiteSpace: "nowrap",
//                       "&:hover": {
//                         backgroundColor: "#218838",
//                         transform: "translateY(-1px)",
//                         boxShadow: "0 6px 20px rgba(40, 167, 69, 0.4)",
//                       },
//                       transition: "all 0.3s ease",
//                     }}
//                   >
//                     GET QUOTE
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           );
//         })}
//       </Box>

//       {/* Confirmation Dialog for Move to Cart and Remove from Wishlist */}
//       <Modal
//         open={openDialog}
//         onClose={() => {
//           setOpenDialog(false);
//           setSelectedModelId(null);
//           setDialogType("");
//         }}
//         aria-labelledby="dialog-title"
//         aria-describedby="dialog-description"
//       >
//         <Box sx={{
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           width: 400,
//           bgcolor: 'background.paper',
//           borderRadius: "12px",
//           boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
//           overflow: 'hidden',
//         }}>
//           <Box sx={{ px: 3, py: 2 }}>
//             <Typography
//               id="dialog-title"
//               variant="h6"
//               component="h2"
//               sx={{ fontWeight: 600 }}
//             >
//               {dialogType === "move"
//                 ? "Confirm Move to Cart"
//                 : "Remove from Wishlist"}
//             </Typography>
//           </Box>

//           <Box sx={{ px: 3, py: 3 }}>
//             <Typography id="dialog-description">
//               {dialogType === "move"
//                 ? "Are you sure you want to move this item to your cart?"
//                 : "Are you sure you want to remove this item from your wishlist?"}
//             </Typography>
//           </Box>

//           <Box sx={{
//             px: 3,
//             py: 2,
//             display: 'flex',
//             justifyContent: 'flex-end',
//             gap: 2
//           }}>
//             <Button
//               onClick={() => {
//                 setOpenDialog(false);
//                 setSelectedModelId(null);
//                 setDialogType("");
//               }}
//               sx={{
//                 border: "1px solid rgb(54 54 54)",
//                 color: "#282828",
//                 padding: "0px 18px"
//               }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={
//                 dialogType === "move" 
//                   ? handleConfirmMove 
//                   : handleConfirmRemoveWishlist
//               }
//               variant="contained"
//               sx={{
//                 backgroundColor: dialogType === "move" ? "#28a745" : "#d32f2f",
//                 color: "#fff",
//                 "&:hover": {
//                   backgroundColor: dialogType === "move" ? "#218838" : "#b71c1c",
//                 },
//               }}
//             >
//               {dialogType === "move" ? "Move to Cart" : "Remove"}
//             </Button>
//           </Box>
//         </Box>
//       </Modal>

//       <InquiryModal
//         open={openInquiryModal}
//         onClose={handleInquiryClose}
//         product={inquiryProduct}
//         imageUrl1={modalImage}
//       />
//     </Box>
//   );
// };

// export default AffordableCarSection;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  IconButton,
  Chip,
  useMediaQuery,
  useTheme,
  Card,
  CardContent,
  Modal,
} from "@mui/material";
import {
  Favorite,
  FavoriteBorder,
  ArrowForwardIos,
  ArrowBackIos,
  Speed,
  LocalGasStation,
  ColorLens,
  Event
} from "@mui/icons-material";
import { useDispatch, useSelector } from 'react-redux';
import { addToWishlist, fetchWishlist, fetchCart } from './store';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import InquiryModal from "./inquiryModal";

const AffordableCarSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [carModels, setCarModels] = useState([]);
  const [carImages, setCarImages] = useState({});
  const [imageLoading, setImageLoading] = useState({});
  const [openInquiryModal, setOpenInquiryModal] = useState(false);
  const [inquiryProduct, setInquiryProduct] = useState(null);
  const [modalImage, setModalImage] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  // Add to Cart Dialog states
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [selectedModelId, setSelectedModelId] = useState(null);

  const wishlistItems = useSelector((state) => state.wishlist.items);
  const cartItems = useSelector((state) => state.cart.items);
  const scrollContainerRef = useRef(null);
  const imageCache = useRef(new Map());

  const enhancedCarModels = carModels.map(car => ({
    ...car,
    savings: Math.floor((car.carPrice || 0) * 0.15),
    features: [
      { icon: <Speed sx={{ fontSize: 16 }} />, label: `${car.carEngineCC || 'N/A'} CC` },
      { icon: <Event sx={{ fontSize: 16 }} />, label: `${car.year || 'N/A'}` },
      { icon: <LocalGasStation sx={{ fontSize: 16 }} />, label: car.carFuel || 'PETROL' },
      { icon: <ColorLens sx={{ fontSize: 16 }} />, label: car.carColor || 'OTHER' }
    ]
  }));

  // OLD API - Paginated affordable car fetch
  // const fetchCarModels = useCallback(async (page = null) => {
  //   try {
  //     setIsRefreshing(true);
  //     const pageToFetch = page !== null ? page : Math.floor(Math.random() * 8);
      
  //     const response = await fetch(`https://car.amar.co.jp/api/master/affordable-car/get-all-affordable-car?page=${pageToFetch}&size=20`, {
  //       headers: {
  //         'accept': 'application/json',
  //         'Accept-Language': 'en'
  //       }
  //     });
  //     const data = await response.json();
  //     setCarModels(data.data || []);
  //   } catch (error) {
  //     console.error("Error fetching car models:", error);
  //   } finally {
  //     setIsRefreshing(false);
  //   }
  // }, []);

  // OLD API - Paginated affordable car fetch with random page logic
  // const fetchCarModels = useCallback(async (page = null) => {
  //   try {
  //     setIsRefreshing(true);

  //     if (page === null) {
  //       const firstRes = await fetch(`https://car.amar.co.jp/api/master/affordable-car/get-all-affordable-car?page=0&size=20`, {
  //         headers: { 'accept': 'application/json', 'Accept-Language': 'en' }
  //       });
  //       const firstData = await firstRes.json();
  //       const totalPages = firstData.totalPages || 1;
  //       const randomPage = Math.floor(Math.random() * totalPages);

  //       if (randomPage === 0) {
  //         setCarModels(firstData.data || []);
  //         return;
  //       }

  //       const response = await fetch(`https://car.amar.co.jp/api/master/affordable-car/get-all-affordable-car?page=${randomPage}&size=20`, {
  //         headers: { 'accept': 'application/json', 'Accept-Language': 'en' }
  //       });
  //       const data = await response.json();
  //       setCarModels(data.data || []);
  //     } else {
  //       const response = await fetch(`https://car.amar.co.jp/api/master/affordable-car/get-all-affordable-car?page=${page}&size=20`, {
  //         headers: { 'accept': 'application/json', 'Accept-Language': 'en' }
  //       });
  //       const data = await response.json();
  //       setCarModels(data.data || []);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching car models:", error);
  //   } finally {
  //     setIsRefreshing(false);
  //   }
  // }, []);

  // NEW API - Random affordable cars fetch
  const fetchCarModels = useCallback(async () => {
    try {
      setIsRefreshing(true);
      const response = await fetch(
        `https://car.amar.co.jp/api/master/affordable-car/get-random-affordable-cars`,
        {
          headers: {
            'accept': 'application/json',
            'accept-language': 'en'
          }
        }
      );
      const data = await response.json();
      setCarModels(data.data || []);
    } catch (error) {
      console.error("Error fetching car models:", error);
    } finally {
      setIsRefreshing(false);
    }
  }, []);

  useEffect(() => {
    fetchCarModels();
  }, [fetchCarModels]);

  const loadCarImages = useCallback(async (models) => {
    const newImageLoading = {};
    const newCarImages = {};
    
    models.forEach(car => {
      newImageLoading[car.carModelId] = true;
    });
    setImageLoading(newImageLoading);

    const imagePromises = models.map(async (car) => {
      const cacheKey = `car-exterior-${car.carModelId}`;
      
      if (imageCache.current.has(cacheKey)) {
        return {
          carModelId: car.carModelId,
          imageUrl: imageCache.current.get(cacheKey),
          fromCache: true
        };
      }

      try {
        const imageUrl = `https://car.amar.co.jp/api/image/car-exterior-images-1/get-image/${car.carModelId}`;
        
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            imageCache.current.set(cacheKey, imageUrl);
            resolve({
              carModelId: car.carModelId,
              imageUrl: imageUrl,
              fromCache: false
            });
          };
          img.onerror = () => {
            resolve({
              carModelId: car.carModelId,
              imageUrl: null,
              fromCache: false
            });
          };
          img.src = imageUrl;
        });
      } catch (error) {
        console.error("Error loading car image:", error);
        return {
          carModelId: car.carModelId,
          imageUrl: null,
          fromCache: false
        };
      }
    });

    const results = await Promise.allSettled(imagePromises);
    
    results.forEach((result) => {
      if (result.status === 'fulfilled') {
        const { carModelId, imageUrl } = result.value;
        newCarImages[carModelId] = imageUrl;
        newImageLoading[carModelId] = false;
      }
    });

    setCarImages(prev => ({ ...prev, ...newCarImages }));
    setImageLoading(prev => ({ ...prev, ...newImageLoading }));
  }, []);

  useEffect(() => {
    if (carModels.length > 0) {
      loadCarImages(carModels);
    }
  }, [carModels, loadCarImages]);

  const handleManualRefresh = () => {
    fetchCarModels();
  };

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      dispatch(fetchWishlist());
      dispatch(fetchCart());
    }
  }, [dispatch]);

  const checkImageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(url);
      img.onerror = () => resolve(null);
      img.src = url;
    });
  };

  const generateValidImageUrls = async (type, modelId, maxCount = 15) => {
    const baseUrl = `https://car.amar.co.jp/api/image/car-${type}-images-`;
    const urls = await Promise.allSettled(
      Array.from({ length: maxCount }, (_, i) =>
        checkImageExists(`${baseUrl}${i + 1}/get-image/${modelId}`)
      )
    );
    return urls
      .filter(result => result.status === 'fulfilled' && result.value)
      .map(result => result.value);
  };

  const fetchProductData = async (carModelId) => {
    try {
      const response = await axios.get(
        `https://car.amar.co.jp/api/dashboard/product/get/Model/details/${carModelId}`
      );
      return response.data?.data || null;
    } catch (err) {
      console.error('Error fetching product data:', err);
      return null;
    }
  };

  const handleInquiryClick = async (e, carModelId) => {
    e.stopPropagation();
    e.preventDefault();
    
    console.log('Inquiry clicked for car:', carModelId);
    
    try {
      const productData = await fetchProductData(carModelId);
      console.log('Product data received:', productData);
      
      if (productData) {
        setInquiryProduct(productData);
        const imageUrls = await generateValidImageUrls("exterior", carModelId);
        console.log('Image URLs:', imageUrls);
        setModalImage(imageUrls[0] || 'carousel/carslider.png');
        setOpenInquiryModal(true);
      } else {
        enqueueSnackbar('Failed to load car details for inquiry.', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error in handleInquiryClick:', error);
      enqueueSnackbar('Error loading car details.', { variant: 'error' });
    }
  };

  const handleInquiryClose = () => {
    setOpenInquiryModal(false);
    setInquiryProduct(null);
    setModalImage(null);
  };

  const handleCarClick = (modelId) => {
    navigate(`/product/${modelId}`);
    window.scrollTo(0, 0);
  };

  // Add to Cart functionality
  const handleAddToCart = async (e, carModelId) => {
    e.stopPropagation();
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/login");
        return;
      }

      const isInCart = cartItems.some((item) => item.modelId === carModelId);
      if (isInCart) {
        enqueueSnackbar("Item is already in your cart", { variant: "warning" });
        return;
      }

      const isFavorite = wishlistItems.some((item) => item.modelId === carModelId);
      
      if (isFavorite) {
        setDialogType("move");
        setSelectedModelId(carModelId);
        setOpenDialog(true);
        return;
      }

      const response = await fetch(
        `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${carModelId}&SelectType=ADD_IN_CART`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            modelId: carModelId,
            type: "ADD_IN_CART",
          }),
        }
      );

      const data = await response.json();
      if (data.code === 200) {
        enqueueSnackbar("Added to cart successfully", { variant: "success" });
        dispatch(fetchCart());
      } else {
        enqueueSnackbar(data.message || "Failed to add to cart", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar("Error adding to cart", { variant: "error" });
      console.error("Error adding to cart:", error);
    }
  };

  // Handle Move to Cart from Wishlist
  const handleConfirmMove = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/login");
        return;
      }

      const response = await fetch(
        `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${selectedModelId}&SelectType=MOVE_TO_CART`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Accept-Language": "en",
            Authorization: `Bearer ${token}`,
          },
          body: "",
        }
      );

      if (response.ok) {
        enqueueSnackbar("Item moved to cart successfully", {
          variant: "success",
        });
        dispatch(fetchWishlist());
        dispatch(fetchCart());
      } else {
        const data = await response.json();
        enqueueSnackbar(data.message || "Failed to move item to cart", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar("Error moving item to cart", { variant: "error" });
      console.error("Error moving to cart:", error);
    } finally {
      setOpenDialog(false);
      setSelectedModelId(null);
      setDialogType("");
    }
  };

  const handleFavoriteClick = async (e, carModelId) => {
    e.stopPropagation();
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/login");
        return;
      }
      const isFavorite = wishlistItems.some((item) => item.modelId === carModelId);
      
      if (isFavorite) {
        // Show remove confirmation dialog
        setDialogType("removeWishlist");
        setSelectedModelId(carModelId);
        setOpenDialog(true);
        return;
      }
      
      const result = await dispatch(addToWishlist(carModelId));
      if (result.success) {
        enqueueSnackbar("Added to wishlist successfully", { variant: "success" });
      } else {
        enqueueSnackbar(result.message || "Failed to add to wishlist", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Error adding to wishlist", { variant: "error" });
      console.error("Error adding to wishlist:", error);
    }
  };

  // Handle Remove from Wishlist
  const handleConfirmRemoveWishlist = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/login");
        return;
      }

      const response = await fetch(
        `https://car.amar.co.jp/api/master/car-cart-and-whishlist/delete/item?Enter%20ModelId=${selectedModelId}`,
        {
          method: "DELETE",
          headers: {
            accept: "application/json",
            "Accept-Language": "en",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        enqueueSnackbar("Item removed from wishlist successfully", {
          variant: "success",
        });
        dispatch(fetchWishlist());
      } else {
        const data = await response.json();
        enqueueSnackbar(data.message || "Failed to remove item from wishlist", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar("Error removing item from wishlist", { variant: "error" });
      console.error("Error removing from wishlist:", error);
    } finally {
      setOpenDialog(false);
      setSelectedModelId(null);
      setDialogType("");
    }
  };

  const isCarFavorite = (car) => {
    return wishlistItems.some((item) => item.modelId === car.carModelId);
  };

  const handleSeeAllAffordableClick = () => {
    navigate("/seeAllAffordableCarModels");
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -600, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 600, behavior: 'smooth' });
    }
  };

  return (
    <Box sx={{ width: "100%", py: 10, position: "relative", backgroundColor:"#F5FEF5" }}>
      {/* Header Section with Refresh Button */}
      <Box sx={{ textAlign: "center", mb: 4, position: 'relative' }}>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "2rem", md: "2.5rem" },
            background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
            mb: 2,
          }}
        >
          Affordable Cars
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: "text.secondary",
            maxWidth: "600px",
            mx: "auto",
            mb: 3,
            fontSize: { xs: "0.9rem", md: "1.1rem" },
            paddingInline:"5px",
          }}
        >
          Quality vehicles that won't break the bank. Smart choices for smart buyers.
        </Typography>

        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          gap: 2,
          flexWrap: 'wrap'
        }}>
          <Button
            variant="outlined"
            onClick={handleManualRefresh}
            disabled={isRefreshing}
            sx={{
              borderColor: "#28a745",
              color: "#28a745",
              px: 2,
              py: 0.2,
              borderRadius: "50px",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#28a745",
                color: "white",
                transform: "translateY(-2px)",
                boxShadow: "0 8px 25px rgba(40, 167, 69, 0.3)",
              },
              "&:disabled": {
                borderColor: "#ccc",
                color: "#ccc",
                cursor: "not-allowed",
                transform: "none",
                boxShadow: "none",
              },
              transition: "all 0.3s ease",
            }}
          >
            {isRefreshing ? "Refreshing..." : "Refresh Cars"}
          </Button>

          <Button
            variant="outlined"
            onClick={handleSeeAllAffordableClick}
            sx={{
              borderColor: "#28a745",
              color: "#28a745",
              px: 2,
              py: 0.2,
              borderRadius: "50px",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#28a745",
                color: "white",
                transform: "translateY(-2px)",
                boxShadow: "0 8px 25px rgba(40, 167, 69, 0.3)",
              },
              transition: "all 0.3s ease",
            }}
          >
            View All Affordable Cars
          </Button>
        </Box>
      </Box>

      {/* Navigation Arrows */}
      {!isMobile && (
        <>
          <IconButton
            onClick={scrollLeft}
            sx={{
              position: "absolute",
              left: 10,
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "white",
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              "&:hover": {
                backgroundColor: "#28a745",
                color: "white",
              },
              zIndex: 10,
            }}
          >
            <ArrowBackIos />
          </IconButton>
          <IconButton
            onClick={scrollRight}
            sx={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "white",
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              "&:hover": {
                backgroundColor: "#28a745",
                color: "white",
              },
              zIndex: 10,
            }}
          >
            <ArrowForwardIos />
          </IconButton>
        </>
      )}

      {/* Enhanced Car Grid */}
      <Box
        ref={scrollContainerRef}
        sx={{
          display: "flex",
          gap: 2,
          overflowX: "auto",
          scrollBehavior: "smooth",
          px: { xs: 2, md: 6 },
          py: 2,
          "&::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        {enhancedCarModels.map((car) => {
          const isFavorite = isCarFavorite(car);
          const isInCart = cartItems.some((item) => item.modelId === car.carModelId);
          
          return (
            <Card
              key={car.carModelId}
              sx={{
                minWidth: 210,
                maxWidth: 290,
                flex: "0 0 auto",
                border: "none",
                borderRadius: 3,
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                cursor: "pointer",
                transition: "all 0.3s ease",
                background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                "&:hover": {
                  transform: "translateY(-8px) scale(1.01)",
                  boxShadow: "0 15px 40px rgba(40, 167, 69, 0.12)",
                },
              }}
              onClick={() => handleCarClick(car.carModelId)}
            >
              {/* Image Section */}
              <Box
                sx={{
                  position: "relative",
                  height: 200,
                  overflow: "hidden",
                  borderTopLeftRadius: 12,
                  borderTopRightRadius: 12,
                  background: "linear-gradient(135deg, #f0fff4 0%, #e8f5e8 100%)",
                }}
              >
                {imageLoading[car.carModelId] ? (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      Loading...
                    </Typography>
                  </Box>
                ) : carImages[car.carModelId] ? (
                  <img
                    src={carImages[car.carModelId]}
                    alt={car.carModelName}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "transform 0.3s ease",
                    }}
                    onLoad={(e) => {
                      e.target.style.opacity = "1";
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/carousel/carslider.png";
                    }}
                  />
                ) : (
                  <img
                    src="/carousel/carslider.png"
                    alt="Car placeholder"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                )}

                {/* Favorite Button */}
                <IconButton
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    backgroundColor: "rgba(255,255,255,0.95)",
                    backdropFilter: "blur(10px)",
                    "&:hover": {
                      backgroundColor: "white",
                      transform: "scale(1.1)",
                    },
                    transition: "all 0.3s ease",
                  }}
                  onClick={(e) => handleFavoriteClick(e, car.carModelId)}
                >
                  {isFavorite ? (
                    <Favorite sx={{ color: "#eb2329" }} />
                  ) : (
                    <FavoriteBorder sx={{ color: "text.secondary" }} />
                  )}
                </IconButton>

                {/* Value Tags */}
                <Box sx={{ position: "absolute", bottom: 8, left: 8, display: "flex", gap: 0.5 }}>
                  {car.savings > 0 && (
                    <Chip
                      label={`Save $${car.savings}`}
                      size="small"
                      sx={{
                        backgroundColor: "rgba(40, 167, 69, 0.9)",
                        color: "white",
                        fontSize: "0.65rem",
                        fontWeight: 600,
                        height: "20px",
                        backdropFilter: "blur(10px)",
                      }}
                    />
                  )}
                </Box>

                                {/* Badges Overlay */}
                <Box
                  sx={{
                    marginTop: "15px",
                    marginLeft: "15px",
                    display: "flex",
                    gap: 0.5,
                    flexWrap: "wrap",
                  }}
                >
                  {car.ourPick && (
                    <Chip
                      label="Our Pick"
                      size="small"
                      sx={{
                        fontSize: isMobile ? "0.55rem" : "0.65rem",
                        height: isMobile ? "16px" : "26px",
                        color: "#dd006e", // Neon pink
                        backgroundColor: "#ffbddf",
                        fontWeight: "bold",
                        border: "1px solid #FF69B4",
                        "&:hover": { backgroundColor: "white" },
                      }}
                    />
                  )}
                  {car.carGrade && (
                    <Chip
                      label={`Grade ${car.carGrade || "A"}`}
                      size="small"
                      sx={{
                        fontSize: isMobile ? "0.55rem" : "0.65rem",
                        height: isMobile ? "16px" : "26px",
                        color: "#009966", // Neon mint
                        backgroundColor: "#9fffe7",
                        fontWeight: "bold",
                        border: "1px solid #00FFAA",
                        "&:hover": { backgroundColor: "white" },
                      }}
                    />
                  )}
                  {car.specialDeal && (
                    <Chip
                      label="Special Offer"
                      size="small"
                      sx={{
                        fontSize: isMobile ? "0.55rem" : "0.65rem",
                        height: isMobile ? "16px" : "26px",
                        backgroundColor: "#d09fff",
                        color: "#6c2aab", // Periwinkle
                        fontWeight: "bold",
                        border: "1px solid #6c2aab",
                        "&:hover": { backgroundColor: "white" },
                      }}
                    />
                  )}
                </Box>
                
              </Box>

              <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                {/* Title and Info */}
                <Box sx={{ mb: 1.5 }}>
                  <Typography
                    variant="h6"
                    title={car.carModelName}
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.95rem",
                      lineHeight: 1.3,
                      mb: 0.5,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      background: "linear-gradient(135deg, #2c3e50 0%, #34495e 100%)",
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      color: "transparent",
                    }}
                  >
                    {car.carModelName}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      fontSize: "0.85rem",
                      mb: 1.5,
                    }}
                  >
                    {car.carCategoriesName}
                  </Typography>
                </Box>

                {/* Features Grid */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  {car.features?.map((feature, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        color: "text.secondary",
                      }}
                    >
                      {feature.icon}
                      <Typography variant="caption" sx={{ fontWeight: 500 }}>
                        {feature.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                {/* Price Section */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pt: 1.5,
                    borderTop: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  <Typography
                    sx={{
                      color: "text.secondary",
                      fontWeight: 400,
                      display: "block",
                      fontSize:'17px'
                    }}
                  >
                    Starting from
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: "#28a745",
                      background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      color: "transparent",
                    }}
                  >
                    {car.carPrice ? `$${car.carPrice.toLocaleString()}` : "Contact Us"}
                  </Typography>
                </Box>

                {/* Action Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "10px",
                    gap: 2,
                  }}
                >
                  {/* <Button
                    variant="contained"
                    onClick={(e) => handleAddToCart(e, car.carModelId)}
                    disabled={isInCart}
                    sx={{
                      flex: 1,
                      backgroundColor: "#28a745",
                      borderRadius: "20px",
                      px: 2.5,
                      py: 0.8,
                      fontWeight: 600,
                      textTransform: "none",
                      boxShadow: "0 3px 12px rgba(40, 167, 69, 0.3)",
                      minHeight: "40px",
                      whiteSpace: "nowrap",
                      "&:hover": {
                        backgroundColor: "#218838",
                        transform: "translateY(-1px)",
                        boxShadow: "0 6px 20px rgba(40, 167, 69, 0.4)",
                      },
                      "&:disabled": {
                        backgroundColor: "#cccccc",
                        cursor: "not-allowed",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    {isFavorite
                      ? "MOVE TO CART"
                      : isInCart
                      ? "ADDED"
                      : "ADD TO CART"}
                  </Button> */}

                  <Button
                    variant="contained"
                    onClick={(e) => handleInquiryClick(e, car.carModelId)}
                    sx={{
                      flex: 1,
                      backgroundColor: "#28a745",
                      borderRadius: "20px",
                      px: 2.5,
                      py: 0.8,
                      fontWeight: 600,
                      textTransform: "none",
                      boxShadow: "0 3px 12px rgba(40, 167, 69, 0.3)",
                      minHeight: "40px",
                      whiteSpace: "nowrap",
                      "&:hover": {
                        backgroundColor: "#218838",
                        transform: "translateY(-1px)",
                        boxShadow: "0 6px 20px rgba(40, 167, 69, 0.4)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    GET QUOTE
                  </Button>
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Box>

      {/* Confirmation Dialog for Move to Cart and Remove from Wishlist */}
      <Modal
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setSelectedModelId(null);
          setDialogType("");
        }}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: "12px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
          overflow: 'hidden',
        }}>
          <Box sx={{ px: 3, py: 2 }}>
            <Typography
              id="dialog-title"
              variant="h6"
              component="h2"
              sx={{ fontWeight: 600 }}
            >
              {dialogType === "move"
                ? "Confirm Move to Cart"
                : "Remove from Wishlist"}
            </Typography>
          </Box>

          <Box sx={{ px: 3, py: 3 }}>
            <Typography id="dialog-description">
              {dialogType === "move"
                ? "Are you sure you want to move this item to your cart?"
                : "Are you sure you want to remove this item from your wishlist?"}
            </Typography>
          </Box>

          <Box sx={{
            px: 3,
            py: 2,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2
          }}>
            <Button
              onClick={() => {
                setOpenDialog(false);
                setSelectedModelId(null);
                setDialogType("");
              }}
              sx={{
                border: "1px solid rgb(54 54 54)",
                color: "#282828",
                padding: "0px 18px"
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={
                dialogType === "move" 
                  ? handleConfirmMove 
                  : handleConfirmRemoveWishlist
              }
              variant="contained"
              sx={{
                backgroundColor: dialogType === "move" ? "#28a745" : "#d32f2f",
                color: "#fff",
                "&:hover": {
                  backgroundColor: dialogType === "move" ? "#218838" : "#b71c1c",
                },
              }}
            >
              {dialogType === "move" ? "Move to Cart" : "Remove"}
            </Button>
          </Box>
        </Box>
      </Modal>

      <InquiryModal
        open={openInquiryModal}
        onClose={handleInquiryClose}
        product={inquiryProduct}
        imageUrl1={modalImage}
      />
    </Box>
  );
};

export default AffordableCarSection;